<script setup lang="ts">
interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  params: any;
}
const props = defineProps<Props>();

function crewBriefing() {
  const id = props.params.data.id;
  props.params.onCrewBriefing(id);
}

function archive() {
  const id = props.params.data.id;
  props.params.onArchive(id);
}

</script>

<template>
  <span class="flex items-center gap-3">
    <button class="ag-grid-button material-icons cursor-pointer text-red" icon="pi pi-folder" v-tooltip.top="'Archive'" variant="text" @click="archive">
      archive
    </button>

    <button
      class="ag-grid-button material-icons cursor-pointer text-red"
      icon="pi pi-briefcase"
      v-tooltip.top="'Crew briefing'"
      variant="text"
      rounded
      @click="crewBriefing"
    >
      business_center
    </button>
  </span>
</template>
